import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpService } from '../shared/services/http.service';


@Injectable({
  providedIn: 'root'
})
export class KanbanService {

  
  httpService=inject(HttpService);

  getKanbanList(data: any, cat: string): Observable<any> {
      return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/dashboard/kanban`,data);
  }


}
